import { ReactNode, Suspense } from "react";
import Layout from "./Layout";
import type { SitemapRoute } from "@/sitemap-routes";

interface AutoLayoutProps {
  route: SitemapRoute;
  children: ReactNode;
}

/**
 * Wrapt een pagina automatisch in `<Layout>` met SEO-props uit `sitemap-routes.ts`.
 * Pagina-componenten hoeven dus zelf geen `<Layout>` meer te wrappen — ze
 * exporteren alleen hun inhoud (fragment of section).
 */
const AutoLayout = ({ route, children }: AutoLayoutProps) => (
  <Layout
    seoTitle={route.seoTitle}
    seoDescription={route.seoDescription}
    seoJsonLd={route.seoJsonLd}
    noIndex={route.noIndex}
  >
    <Suspense fallback={<div className="min-h-[60vh]" aria-hidden />}>{children}</Suspense>
  </Layout>
);

export default AutoLayout;
